// ＳＰメニューのハンバーガー用

{
  // 下部バーのハンバーガー（#sp-menu）とヘッダー左端のハンバーガー（[data-sp-modal-toggle]）で
  // 同じモーダルを開閉する。どちらから開いても両方の見た目が揃うよう、状態は1か所で持つ
  const spModalMenu = document.getElementById('shopify-section-schmatz-sp-modal');
  const body = document.querySelector('body');
  const triggers = [
    document.getElementById('sp-menu'),
    ...document.querySelectorAll('[data-sp-modal-toggle]'),
  ].filter(Boolean);

  if (spModalMenu && triggers.length) {
    // 画面下のバーが無い（＝閉じる手段がヘッダーの×だけ）ときにだけ、
    // ヘッダーをモーダルより前に出す CSS を効かせる
    if (document.querySelector('[data-sp-modal-toggle]') && !document.getElementById('sp-menu')) {
      document.documentElement.classList.add('sz-burger-solo');
    }

    const setState = (open) => {
      spModalMenu.classList.toggle('open', open);
      body.classList.toggle('stop', open);
      triggers.forEach((trigger) => {
        trigger.classList.toggle('open', open);
        if (trigger.hasAttribute('aria-expanded')) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        setState(!spModalMenu.classList.contains('open'));
      });
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && spModalMenu.classList.contains('open')) setState(false);
    });
  }
}


$(function () {
  $('.js-toggle').click(function() {
    $(this).toggleClass('close')
    $(this).next().slideToggle();
  })
});